import { Outlet, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { ComplaintDetailDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ComplaintSideContent } from './SideContent'

const ComplaintDetailPage = () => {
  const { id } = useParams()

  const { loading, data } = useQuery(ComplaintDetailDocument, {
    variables: {
      id: String(id),
    },
  })

  const complaint = data?.complaints.complaint

  if (loading || !complaint) {
    return (
      <Box padding="s40" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <Box flexDirection="row" width="full" height="full" paddingBottom="s20">
      <Box
        flexNoShrink
        height="full"
        overflowY="auto"
        overflowX="hidden"
        paddingY="s20"
        paddingX="s24"
        border={{ right: { style: 'solid', width: 's1', color: 'grey200' } }}
        style={{ width: '75%' }}
        data-scroll-container
      >
        <Outlet context={{ complaint }} />
      </Box>
      <Box
        flexGrow
        height="full"
        overflowY="auto"
        paddingTop="s20"
        paddingRight="s16"
        paddingLeft="s8"
        paddingBottom="s24"
      >
        <ComplaintSideContent data={complaint} />
      </Box>
    </Box>
  )
}

export default ComplaintDetailPage
